import { usePortalVersion } from '../../contexts/PortalVersionContext.jsx';

/**
 * PortalVersionToggle — switch between V1 (classic) and V2 (modern) portal.
 * Accepts a `variant` prop to style itself for each navigation context.
 *
 * @param {{ variant: 'v1' | 'v2' }} props
 */
const PortalVersionToggle = ({ variant = 'v1' }) => {
    const { portalVersion, togglePortalVersion } = usePortalVersion();

    if (variant === 'v2') {
        return (
            <button
                type="button"
                onClick={togglePortalVersion}
                className="nav2-version-toggle"
                title="Switch to classic portal"
            >
                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 15L3 9m0 0l6-6M3 9h12a6 6 0 010 12h-3" />
                </svg>
                Switch to Classic
            </button>
        );
    }

    // V1 variant — pill button for old sidebar
    return (
        <button
            type="button"
            onClick={togglePortalVersion}
            className="btn btn-sm mt-2"
            style={{
                background: portalVersion === 'v2' ? 'var(--color-primary)' : 'linear-gradient(135deg, #0081c7 0%, #00a2fa 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: '20px',
                padding: '6px 16px',
                fontSize: 'var(--font-size-xs)',
                fontWeight: '600',
                cursor: 'pointer',
                width: '75%',
                transition: 'all 200ms ease',
            }}
            title={portalVersion === 'v2' ? 'Switch to classic portal' : 'Try the new portal design'}
        >
            {portalVersion === 'v2' ? '← Classic View' : '✦ Try Portal v2'}
        </button>
    );
};

export default PortalVersionToggle;
